import {
  type OfferCheapestPriceV1,
  type OfferV11,
} from '@redteclab/api/clients/bully'

export const priceAccessorGetThirtyDaysLowestPrice = (
  offer: OfferV11,
): OfferCheapestPriceV1 | null =>
  offer.offerPrice?.additionalInformation?.cheapestPrice ?? null
